import { createRoute } from '@tanstack/react-router'
import { Outlet } from '@tanstack/react-router'

import { rootRoute } from '../root'

export const sponsorsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'sponsors',
  component: Outlet,
})
